import DefaultResetForm from '@/components/DefaultResetForm';
import { CustomTextField } from '@/components/Formik/CustomTextField';
import InformationCard from '@/components/InformationCard';
import { api } from '@/services/apiClient';
import { resetPassword } from '@/validators/resetUsersInfo';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { IModalSuccessData } from '.';

interface ResetPassword {
  onSuccess: (value: IModalSuccessData) => void;
  handleClose: () => void;
}

interface FormValues {
  current_password: string;
  password: string;
  re_new_password: string;
}

const ResetPassword = ({ onSuccess, handleClose }: ResetPassword) => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  const handleSubmitResetPasswordForm = async (values: FormValues) => {
    const { password, ...rest } = values;
    await api.post('/auth/users/set_password/', {
      ...rest,
      new_password: password,
    });

    onSuccess({
      isOpen: true,
      text: 'Sua senha foi alterada com sucesso!',
    });
  };

  return (
    <DefaultResetForm
      title=""
      buttonText="salvar"
      handleClose={handleClose}
      handleCancel={handleClose}
      onSubmit={values => handleSubmitResetPasswordForm(values as FormValues)}
      validationSchema={resetPassword}
      initialValues={{
        current_password: '',
        password: '',
        re_new_password: '',
      }}
    >
      {!smUp && (
        <Typography component="h3" variant="h6">
          Alterar senha
        </Typography>
      )}
      <Box
        sx={{
          display: 'grid',
          alignContent: 'space-between',
          gap: 2,
        }}
      >
        <CustomTextField
          label="Senha atual *"
          name="current_password"
          type="password"
          variant="standard"
        />
        <CustomTextField
          label="Nova senha *"
          name="password"
          type="password"
          variant="standard"
          FormHelperTextProps={{
            id: 'password-helper-text',
          }}
        />
        <CustomTextField
          label="Confirmar nova senha *"
          name="re_new_password"
          type="password"
          variant="standard"
        />
      </Box>
      <Box marginBottom="24px">
        <InformationCard text="Utilize letras maiúsculas, letras minúsculas, números, símbolos e no mínimo 8 caracteres." />
      </Box>
    </DefaultResetForm>
  );
};

export default ResetPassword;
